<template>
    <div class="material-panel" ref="scrollDomRef">
        <material-list ref="listRef"
            @onMaterialClick="onMaterialClick"
            :tplGroupId="tplGroupId"
            :projectId="projectId"></material-list>
    </div>
</template>
<script>
    import {MATERIAL_UPLOAD} from '../../../request/api/fileupload-api';
    import {material_type} from '@/const.js';
    import materialList from '../../templateFree/template-aside/material-list-index'
    const DEFAULT_PAGE_SIZE = 20;
    export default {
        components:{
            materialList,
        },
        props:{
            projectId: {type: String, require: true},
            tplGroupId: {type: String, require: true},
            validateLocal: { // table编辑时，插入图片不需要验证，直接插入上传图片
                type: Boolean,
                default:false
            },
            publicVisible: Boolean
        },
        data(){
            return {
                uploadUrl: MATERIAL_UPLOAD,
                progressVal: 0,
                materialPage: {
                    projectId: null,
                    nameOrTagName: '',
                    type: material_type.element,
                    pageSize: DEFAULT_PAGE_SIZE,
                    pageNum: 1,
                    widthHeights: null, // ['100x200', '255x300']
                    tagNames: [],
                    tplGroupIds: null
                },
                mQueryLoading: false,
                networkUploadVisible: false,
                localParseLoading: false,
                progressLoading: false,
                searchMessage: '',
                materialArray: [],
                isPublicMaterial: false
            }
        },
        computed: {
            materialTags() {
                return this.$store.state.app.materialTags
            },
            selectedMaterialItem(){
                return this.$store.state.templateGroup.selectedItem;
            },
            disabledUploader() {
                return (this.selectedMaterialItem === null && this.validateLocal) || this.localParseLoading;
            },
            hasGroupMaterial(){
                let list = this.$store.state.templateGroup.materialGroupList;
                return list && list.length > 0;
            }
        },
        destroyed(){
            window.removeEventListener('message', this.onPSCallback);
        },
        mounted(){
            window.addEventListener('message', this.onPSCallback);
        },
        methods:{
            onPSCallback(e){
                if(!e.data){
                    return;
                }
                let {psDataUrl, properties} = e.data;
                if(psDataUrl){
                    this.triggerMaterialChange({widthHeight: properties, url: psDataUrl, html: ''});
                }
            },
            onMaterialClick(item) {
                this.triggerMaterialChange({url: item.url, widthHeight: item.widthHeight, isLocalImg: true,  materialGroup: null});
            },
            triggerMaterialChange(item){
                this.$emit('onMaterialClick', item)
            },
            _search(name){
                this.$refs.listRef._search(name);
            }
        }
    }
</script>
<style lang="scss">
@import "material-panel";
</style>